var guideV2Pages = (function () {
  var promoBar, headerElem, content, sidebarLinksParent, sidebarLinks, tocSect, sideDivWrapper, windowYOffset, headerHabitatWrap, nudgeFixTop,
    socialShareInterval = null; // Variable to store the interval
  
  return {
    init: init,
  };

  function init() {
    headerElem = document.getElementById("header-habitat"),
    content = document.querySelector('.guide-template__main'),
    sidebarLinksParent = document.querySelectorAll('.guide-template__toc-list ul li'),
    sidebarLinks = document.querySelectorAll('.guide-template__toc-list ul li a'),
    tocSect = document.querySelector('.guide-template__sidebar .guide-template__toc-section'),
    sideDivWrapper = document.querySelector('.guide-template__articles-box');
    nudgeFixTop = sideDivWrapper.getAttribute('data-nudgefixtop');
    uiBindings();
  }

  function uiBindings() {
    function handleScrollAndResizeEvents() {
      guideStickyHeader();
      stickyTocOnScroll();
      highlightToc();
      setArticleBoxPosition();
      getGuideProgressBar();
      adjustSocialSharePosition();
    }

    window.addEventListener('scroll', handleScrollAndResizeEvents);
    window.addEventListener('resize', handleScrollAndResizeEvents);

    if (sidebarLinks){
      for (var i = 0; i < sidebarLinks.length; i++) {
        sidebarLinks[i].addEventListener('click', setActiveToc);
      }
    }

    var tocBtn = document.querySelector('.guide-template__content .guide-template__toc-heading-mob');
    if (tocBtn) {
      tocBtn.addEventListener("click", function () {
        var that = this;
        if (that.parentElement.classList.contains("guide-template__toc--active")) {
          that.parentElement.classList.remove("guide-template__toc--active");
          that.setAttribute('aria-expanded', 'false');
        } else {
          that.parentElement.classList.add("guide-template__toc--active");
          that.setAttribute('aria-expanded', 'true');
        }
      });
    }

    var sharePageLink = document.querySelector('.guide-template__social-share-link-web'),
      openShareBtn = document.querySelector('.guide-template__social-share-link-icon');
    
    if (sharePageLink) {
      sharePageLink.addEventListener('click', copyPageLinkClipboard);
    }

    if (openShareBtn) {
      openShareBtn.addEventListener('click', openSocialShare);
    }

    //open anchor links for post content in new tab
    var guideAnchorLinkElem = document.querySelectorAll('.guide-template__post-content a:not(.open-csf-form-v2, .open-csf-form)');
    for (var i = 0; i < guideAnchorLinkElem.length; i++) {
      guideAnchorLinkElem[i].setAttribute('target', '_blank');
      guideAnchorLinkElem[i].setAttribute('rel', 'noopener');
    }

    // Initial positioning check for social share
    adjustSocialSharePosition();
    
    // Check for widget changes periodically (since it's loaded via GTM)
    var retryCount = 0,
      maxRetries = 20; // 250ms * 20 = 5 seconds
    
    socialShareInterval = setInterval(function() {
      // Try to position social share
      adjustSocialSharePosition();
      
      // Stop after max retries if interval wasn't cleared by adjustSocialSharePosition
      retryCount++;
      if (retryCount >= maxRetries) {
        clearInterval(socialShareInterval);
        socialShareInterval = null;
      }
    }, 250);
  }

  function guideStickyHeader() {
    if (headerElem && !headerElem.classList.contains('header-habitat--has-secondary-menu') && window.innerWidth > 979) {
      promoBar = document.getElementById('promo-notification');
      headerHabitatWrap = document.getElementById('header-habitat-wrap');
      if (promoBar) {
        if (window.pageYOffset < promoBar.offsetHeight) { 
          headerHabitatWrap.style.top = - window.pageYOffset + 'px';
        } else {
          headerHabitatWrap.style.top = - promoBar.offsetHeight + 'px';
        }
      }
      


      if (Cookie.read('closePromoNotification') && window.pageYOffset > 5) {
        document.body.classList.add('guide-sticky-header');
      } else if (promoBar && window.pageYOffset > 51) {
        document.body.classList.add('guide-sticky-header');
      } else if (window.pageYOffset >= 5 && !promoBar) {
        document.body.classList.add('guide-sticky-header');
      } else {
        document.body.classList.remove('guide-sticky-header');
      }
    } else {
      document.body.classList.remove('guide-sticky-header');
    }
  }

  function getGuideProgressBar() {
    var progressDom = document.querySelector('.guide-progress-bar');
    if (window.innerWidth >= 980 && progressDom) {
      var pixels = window.pageYOffset,
        pageHeight = document.body.scrollHeight - window.innerHeight,
        progress = (100 * pixels) / pageHeight;

      progressDom.style.width = progress + '%';
    }
  }

  function stickyTocOnScroll() {
    if (window.innerWidth >= 1280 && tocSect) {
      var relatedPosts = document.getElementById('guide-related-posts'),
        guideFooterBannerSectionCTA = document.getElementById('guideFooterBannerSectionCTA'),
        sidebar = document.querySelector('.guide-template__sidebar'),
        sidebarBottom = sidebar.getBoundingClientRect().bottom,
        windowYOffset = window.pageYOffset;

      if (windowYOffset <= content.offsetTop) {
        if (tocSect.classList.contains('toc-sticky') || tocSect.classList.contains('toc-bottom')) {
          tocSect.classList.remove('toc-sticky', 'toc-bottom');
        }
      } else if ((sidebarBottom - 131) <= 0) {
        if (tocSect.classList.contains('toc-sticky') || tocSect.classList.contains('toc-bottom')) {
          tocSect.classList.remove('toc-sticky', 'toc-bottom');
        }
      } else if ((windowYOffset > content.offsetTop) && ((windowYOffset + tocSect.offsetHeight) < (relatedPosts ? (relatedPosts.offsetTop - 168) : (guideFooterBannerSectionCTA.offsetTop - 168)))) {
        if (!tocSect.classList.contains('toc-sticky')) {
          tocSect.classList.add('toc-sticky');
        }
        if (tocSect.classList.contains('toc-bottom')) {
          tocSect.classList.remove('toc-bottom');
        }
      } else {
        if (tocSect.classList.contains('toc-sticky')) {
          tocSect.classList.remove('toc-sticky');
        }
        if (!tocSect.classList.contains('toc-bottom')) {
          tocSect.classList.add('toc-bottom');
        }
      }
    } else {
      tocSect.classList.remove('toc-sticky', 'toc-bottom');
    }
  }

  function setArticleBoxPosition() {
    if (window.innerWidth >= 1280 && sideDivWrapper) {
      var contentRect = content.getBoundingClientRect(),
        contentInner = document.querySelector('.guide-template__content'),
        contentInnerStyles = window.getComputedStyle(contentInner),
        relatedPosts = document.getElementById('guide-related-posts'),
        guideFooterBannerSectionCTA = document.getElementById('guideFooterBannerSectionCTA'),
        sideDiv1 = document.querySelector('#guide-template__popup-csf'),
        sideDiv2 = document.querySelector('#guide-template__featured-article'),
        sideDiv3 = document.querySelector('#guide-template__read-article'),
        contentHeight = Math.round(content.offsetHeight / 4),
        scrollPoint1x = content.offsetTop + contentHeight,
        scrollPoint2x = scrollPoint1x + contentHeight,
        scrollPoint3x = scrollPoint2x + contentHeight,
        windowYOffset = window.pageYOffset;
      
      sideDivWrapper.classList.add('sticky');
      sideDivWrapper.style.top = tocSect.offsetHeight + 84 + "px";
      sideDivWrapper.style.left = (contentInner.offsetWidth + contentRect.left + parseFloat(contentInnerStyles.marginRight)) + 'px';

      if (windowYOffset <= content.offsetTop) {
        sideDivWrapper.classList.remove('sticky')
      } else if (((sideDivWrapper.getBoundingClientRect().bottom) - 131) <= 0) {
        sideDivWrapper.classList.remove('sticky')
      } else if ((windowYOffset > content.offsetTop) && ((windowYOffset + tocSect.offsetHeight + sideDivWrapper.offsetHeight) < (relatedPosts ? (relatedPosts.offsetTop - 168) : (guideFooterBannerSectionCTA.offsetTop - 168)))) {
        sideDivWrapper.classList.add('sticky');
      } else {
        sideDivWrapper.classList.remove('sticky');
      }

      // Handle Sticky Divs Below TOC
      if (nudgeFixTop == '1') {
        sideDiv1.classList.add('sticky');
        return false;
      } 
      if (windowYOffset > scrollPoint1x && windowYOffset < scrollPoint2x) {
        sideDiv1.classList.add('sticky');
        sideDiv2.classList.remove('sticky');
        sideDiv3.classList.remove('sticky');
      } else if (windowYOffset >= scrollPoint2x && windowYOffset < scrollPoint3x) {
          sideDiv1.classList.remove('sticky');
          sideDiv2.classList.add('sticky');
          sideDiv3.classList.remove('sticky');
      } else if (windowYOffset >= scrollPoint3x) {
          sideDiv1.classList.remove('sticky');
          sideDiv2.classList.remove('sticky');
          sideDiv3.classList.add('sticky');
      } else {
          sideDiv1.classList.remove('sticky');
          sideDiv2.classList.remove('sticky');
          sideDiv3.classList.remove('sticky');
      }
    } else {
      sideDivWrapper.classList.remove('sticky');
    }
  }

  function highlightToc() {
    if (window.innerWidth >= 1280 && tocSect && tocSect.classList.contains('toc-sticky')) {
      var activeToc = document.querySelector(".guide-template__toc-list ul li a.active"),
        activeIndex = 0;
      
      for (var s = 0; s < sidebarLinks.length; s++) {
        var tocHeadingID = sidebarLinks[s].getAttribute("data-scrollto"),
        tocHeadingDom = document.querySelector(tocHeadingID);

        if (tocHeadingDom) {
          var tocHeadingDomRect = tocHeadingDom.getBoundingClientRect();
          if ((tocHeadingDomRect.top - 90) < 0) {
            activeIndex = s;
          }
        }
      }

      if (activeToc && activeToc.classList.contains('active')) {
        activeToc.classList.remove("active");
        var parentLi = sidebarLinks[activeIndex].parentElement;
        // If the clicked link is not inside a nested list
        if (parentLi.parentElement.tagName === 'UL' && parentLi.parentElement.parentElement.tagName !== 'LI') {
          parentLi.classList.remove('active');
        }
        // If the clicked link is inside a nested list, add 'active' to its grandparent list item
        if (parentLi.parentElement.parentElement && parentLi.parentElement.parentElement.tagName === 'LI') {
          parentLi.parentElement.parentElement.classList.remove('active');
        }
      }
      
      // Scroll the active link into view within the TOC
      sidebarLinks[activeIndex].scrollIntoView({ behavior: "smooth", block: "center" });

      setActiveTocParent(sidebarLinks[activeIndex]);
    }
  }

  function setActiveToc(event) {
    var that = event.target;
    setActiveTocParent(that);
  }

  function setActiveTocParent(activeToc) {
    for (var a = 0; a < sidebarLinksParent.length; a++) {
      sidebarLinksParent[a].classList.remove('active');
    }
    for (var b = 0; b < sidebarLinks.length; b++) {
      sidebarLinks[b].classList.remove('active');
    }
    activeToc.classList.add('active');
    var parentLi = activeToc.parentElement;
    // If the clicked link is not inside a nested list
    if (parentLi.parentElement.tagName === 'UL' && parentLi.parentElement.parentElement.tagName !== 'LI') {
      parentLi.classList.add('active');
    }
    // If the clicked link is inside a nested list, add 'active' to its grandparent list item
    if (parentLi.parentElement.parentElement && parentLi.parentElement.parentElement.tagName === 'LI') {
      parentLi.parentElement.parentElement.classList.add('active');
    }
  }

  function copyPageLinkClipboard(event) {
    event.preventDefault();
    var that = event.target,
      pageLink = that.getAttribute('data-href'),
      tempInput = document.createElement('input');
    
      tempInput.value = decodeURIComponent(pageLink);
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      that.classList.add('show-tooltip');
      // Hide tooltip after 2 seconds
      setTimeout(function() {
          that.classList.remove('show-tooltip');
      }, 2000);
  }

  function openSocialShare(event) {
    event.preventDefault();
    var that = event.target;
    thatParent = that.parentElement;

    thatParent.classList.toggle('show-share');
  }

  function adjustSocialSharePosition() {
    // Only apply on mobile/tablet layouts where both widgets are circular
    if (window.innerWidth < 1280 && window.innerWidth >= 980) {
      var socialShareSection = document.querySelector('.guide-template__social-section'),
        gtmWidget = document.querySelector('#breakout-command-bar');

      if (socialShareSection && gtmWidget && gtmWidget.shadowRoot) {
        var gtmwidgetChat = gtmWidget.shadowRoot.querySelector('.command-bar-positioned');
        
        // Set up MutationObserver to watch for changes in shadow DOM
        if (!gtmWidget.hasAttribute('data-observer-setup')) {
          var observer = new MutationObserver(function(mutations) {
            // Re-run positioning when shadow DOM changes
            setTimeout(adjustSocialSharePosition, 100); // Small delay to ensure DOM updates
          });
          
          // Observe changes in shadow DOM
          observer.observe(gtmWidget.shadowRoot, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
          });
          
          gtmWidget.setAttribute('data-observer-setup', 'true');
          
          // Clear the interval since MutationObserver will handle updates now
          if (socialShareInterval) {
            clearInterval(socialShareInterval);
            socialShareInterval = null;
          }
        }

        // Only proceed if we can access the actual widget element
        if (gtmwidgetChat) {
          var gtmwidgetChatRect = gtmwidgetChat.getBoundingClientRect(),
            gtmwidgetChatHeight = gtmwidgetChatRect.height;

          // Check if GTM widget is visible and positioned
          if (gtmwidgetChatHeight > 0 && gtmwidgetChat && window.getComputedStyle(gtmwidgetChat).display !== 'none') {
            // Move social share above the GTM widget with dynamic height
            var newBottomPosition = gtmwidgetChatHeight + (16 * 2); // Add extra spacing
            socialShareSection.style.bottom = newBottomPosition + 'px';
            socialShareSection.setAttribute('data-adjusted-for-widget', 'true');
            socialShareSection.setAttribute('data-widget-height', gtmwidgetChatHeight);
          } else {
            // Reset to default position if widget not visible
            socialShareSection.style.bottom = '20px';
            socialShareSection.removeAttribute('data-adjusted-for-widget');
            socialShareSection.removeAttribute('data-widget-height');
          }
        } else {
          // Shadow DOM not accessible or widget not found, reset to default
          socialShareSection.style.bottom = '20px';
          socialShareSection.removeAttribute('data-adjusted-for-widget');
          socialShareSection.removeAttribute('data-widget-height');
        }
      }
    } else {
      // Reset positioning for other breakpoints
      var socialShareSection = document.querySelector('.guide-template__social-section');
      if (socialShareSection) {
        socialShareSection.style.bottom = '';
        socialShareSection.removeAttribute('data-adjusted-for-widget');
        socialShareSection.removeAttribute('data-widget-height');
      }
      if (socialShareInterval) {
        clearInterval(socialShareInterval);
        socialShareInterval = null;
      }
    }
  }
})();

guideV2Pages.init();